export default __webpack_public_path__ + "static/media/fitbit.7abb9d09.jpg";